/**
 * 시간축 라벨 포맷터 — hour 단위 (예: 3PM, 12:30AM)
 */
export const formatHourLabel = (timestampMs: number): string => {
  const date = new Date(timestampMs);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  const ampm = hours >= 12 ? 'PM' : 'AM';

  if (minutes === 0) {
    return `${hour12}${ampm}`;
  }

  return `${hour12}:${String(minutes).padStart(2, '0')}${ampm}`;
};

/**
 * 시간축 라벨 포맷터 — day 단위 (예: 02/15)
 */
export const formatDayLabel = (timestampMs: number): string => {
  const date = new Date(timestampMs);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${month}/${day}`;
};

/**
 * 시간축 라벨 포맷터 — week 단위 (예: 02/15)
 */
export const formatWeekLabel = (timestampMs: number): string => {
  const date = new Date(timestampMs);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${month}/${day}`;
};
